var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_26767_6843)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint1_radial_26767_6843)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26767_6843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 10H16.25C12.7988 10 10 12.7988 10 16.25V23.75C10 27.2013 12.7988 30 16.25 30H23.75C27.2013 30 30 27.2013 30 23.75V16.25C30 12.7988 27.2013 10 23.75 10ZM28.125 23.75C28.125 26.1625 26.1625 28.125 23.75 28.125H16.25C13.8375 28.125 11.875 26.1625 11.875 23.75V16.25C11.875 13.8375 13.8375 11.875 16.25 11.875H23.75C26.1625 11.875 28.125 13.8375 28.125 16.25V23.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15C17.2387 15 15 17.2387 15 20C15 22.7613 17.2387 25 20 25C22.7613 25 25 22.7613 25 20C25 17.2387 22.7613 15 20 15ZM20 23.125C18.2775 23.125 16.875 21.7225 16.875 20C16.875 18.2763 18.2775 16.875 20 16.875C21.7225 16.875 23.125 18.2763 23.125 20C23.125 21.7225 21.7225 23.125 20 23.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3752 15.2915C25.7432 15.2915 26.0415 14.9932 26.0415 14.6252C26.0415 14.2573 25.7432 13.959 25.3752 13.959C25.0073 13.959 24.709 14.2573 24.709 14.6252C24.709 14.9932 25.0073 15.2915 25.3752 15.2915Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26767_6843",
    x1: 2.33387,
    y1: 2.10292,
    x2: 14.9455,
    y2: 50.8863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_26767_6843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1097 40) rotate(32.1601) scale(37.3579 26.8853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26767_6843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9d2c8ff995255ea052acff9ba00bf466.svg";
export { ForwardRef as ReactComponent };